/**
 * Evita requisições duplicadas: se já existe uma requisição em andamento
 * para o mesmo recurso, retorna a mesma Promise em vez de iniciar outra.
 */
import axios from 'axios';

const pendingRequests = new Map();

const getRequestKey = (url, config = {}) => {
    const auth = config?.headers?.Authorization || config?.headers?.authorization || 'none';
    return `${url}::${auth}`;
};

export const getSignerHash = (url, config = {}) => {
    const key = getRequestKey(url, config);
    const existing = pendingRequests.get(key);

    if (existing) {
        return existing;
    }

    const promise = axios.get(url, config).finally(() => {
        pendingRequests.delete(key);
    });

    pendingRequests.set(key, promise);
    return promise;
};
